@if (documents_()?.length) {
	<div
		class="overflow-y-auto max-h-[80vh] h-full border border-gray-200 divide-y divide-gray-200 [&.cdk-drop-list-dragging&>*:not(.cdk-drag-placeholder)]:duration-300"
		cdkDropList
		(cdkDropListDropped)="drop($event)"
		[ngClass]="
			withinEnvelopView_() ? 'rounded-t-none rounded-lg' : 'rounded-xl'
		"
	>
		@for (docMeta of documents_(); track docMeta.id) {
			<div
				cdkDrag
				[cdkDragClass]="[
					'bg-gray-50',
					'border-2',
					'border-primary-600',
					'rounded-xl',
				]"
				[cdkDragPreviewClass]="['shadow-lg']"
			>
				<ui-doc-list-item
					[reorderable]="true"
					[listView]="true"
					[documentMetadata]="docMeta"
					[currentPackageId]="packageId_()"
					[matterSource]="matterSource_()"
					(documentClick)="onDocumentPreview(docMeta)"
					[isSelected]="selectedDocumentIds_().includes(docMeta.id)"
					[analyticContext]="ANALYTIC_CONTEXT.MATTER_BUILDER"
					[includeInDropdown]="['export', 'rename', 'reset', 'duplicate']"
					[customDropdownItems]="dropdownItems_()[docMeta.id]"
				/>
			</div>
		}
	</div>
} @else if (!withinEnvelopView_()) {
	<ui-empty
		[preset]="UI_EMPTY_PRESET.NO_DOCUMENTS"
		[testHook]="testHooks.EmptyNoDocuments"
	/>
} @else {
	<div class="overflow-y-auto rounded-t-none rounded-lg border border-gray-200">
		<ui-empty
			[preset]="UI_EMPTY_PRESET.NO_DOCUMENTS"
			[testHook]="testHooks.EmptyEnvelopeView"
		/>
	</div>
}
